/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiAgencyinquiryEditPut } from '../fn/agency-inquiry/api-agencyinquiry-edit-put';
import { ApiAgencyinquiryEditPut$Params } from '../fn/agency-inquiry/api-agencyinquiry-edit-put';
import { apiAgencyinquiryEmptyInquiryGet } from '../fn/agency-inquiry/api-agencyinquiry-empty-inquiry-get';
import { ApiAgencyinquiryEmptyInquiryGet$Params } from '../fn/agency-inquiry/api-agencyinquiry-empty-inquiry-get';
import { apiAgencyinquiryGet } from '../fn/agency-inquiry/api-agencyinquiry-get';
import { ApiAgencyinquiryGet$Params } from '../fn/agency-inquiry/api-agencyinquiry-get';
import { apiAgencyinquiryPut } from '../fn/agency-inquiry/api-agencyinquiry-put';
import { ApiAgencyinquiryPut$Params } from '../fn/agency-inquiry/api-agencyinquiry-put';
import { apiAgencyinquirySignUpRequestPost } from '../fn/agency-inquiry/api-agencyinquiry-sign-up-request-post';
import { ApiAgencyinquirySignUpRequestPost$Params } from '../fn/agency-inquiry/api-agencyinquiry-sign-up-request-post';
import { IncomingInquiryDto } from '../models/incoming-inquiry-dto';
import { InquiryDto } from '../models/inquiry-dto';
import { NotificationMessage } from '../models/notification-message';

@Injectable({ providedIn: 'root' })
export class AgencyInquiryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAgencyinquirySignUpRequestPost()` */
  static readonly ApiAgencyinquirySignUpRequestPostPath = '/api/agencyinquiry/sign-up-request';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencyinquirySignUpRequestPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiAgencyinquirySignUpRequestPost$Response(params?: ApiAgencyinquirySignUpRequestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiAgencyinquirySignUpRequestPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencyinquirySignUpRequestPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiAgencyinquirySignUpRequestPost(params?: ApiAgencyinquirySignUpRequestPost$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiAgencyinquirySignUpRequestPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiAgencyinquiryGet()` */
  static readonly ApiAgencyinquiryGetPath = '/api/agencyinquiry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencyinquiryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencyinquiryGet$Response(params?: ApiAgencyinquiryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InquiryDto>>> {
    return apiAgencyinquiryGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencyinquiryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencyinquiryGet(params?: ApiAgencyinquiryGet$Params, context?: HttpContext): Observable<Array<InquiryDto>> {
    return this.apiAgencyinquiryGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<InquiryDto>>): Array<InquiryDto> => r.body)
    );
  }

  /** Path part for operation `apiAgencyinquiryPut()` */
  static readonly ApiAgencyinquiryPutPath = '/api/agencyinquiry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencyinquiryPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgencyinquiryPut$Response(params?: ApiAgencyinquiryPut$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiAgencyinquiryPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencyinquiryPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgencyinquiryPut(params?: ApiAgencyinquiryPut$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiAgencyinquiryPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiAgencyinquiryEditPut()` */
  static readonly ApiAgencyinquiryEditPutPath = '/api/agencyinquiry/edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencyinquiryEditPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgencyinquiryEditPut$Response(params?: ApiAgencyinquiryEditPut$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiAgencyinquiryEditPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencyinquiryEditPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgencyinquiryEditPut(params?: ApiAgencyinquiryEditPut$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiAgencyinquiryEditPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiAgencyinquiryEmptyInquiryGet()` */
  static readonly ApiAgencyinquiryEmptyInquiryGetPath = '/api/agencyinquiry/empty-inquiry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencyinquiryEmptyInquiryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencyinquiryEmptyInquiryGet$Response(params?: ApiAgencyinquiryEmptyInquiryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<IncomingInquiryDto>> {
    return apiAgencyinquiryEmptyInquiryGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencyinquiryEmptyInquiryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencyinquiryEmptyInquiryGet(params?: ApiAgencyinquiryEmptyInquiryGet$Params, context?: HttpContext): Observable<IncomingInquiryDto> {
    return this.apiAgencyinquiryEmptyInquiryGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<IncomingInquiryDto>): IncomingInquiryDto => r.body)
    );
  }

}
